import clsx from 'clsx';
import InterviewSummaryBlockCombobox from 'components/comboboxes/InterviewSummaryBlockCombobox';
import MutedText from 'components/common/MutedText';
import HubertLabel from 'components/HubertUI/HubertLabel';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'rtk/query/hooks';
import { updateQuestionInterviewSummaryBlock } from 'rtk/TemplateSlice';
import { EEventType } from 'types/events.enum';
import { useTemplateId } from 'hooks/useTemplate';
import { useQuestionEditorContext } from '../context/create-question.context';

const InTemplateInterviewSummaryBlock = () => {
  const { t } = useTranslation('Questionsv2');
  const dispatch = useAppDispatch();
  const { questionId } = useQuestionEditorContext();
  const templateId = useTemplateId();
  const interviewSummaryBlocks =
    useAppSelector((state) => state.Template?.present?.c?.interview_summary?.summary_blocks) ?? [];

  const blockList = interviewSummaryBlocks
    .filter((block) => block.details?.length)
    .map((block) => ({
      label: block.name,
      value: block.id,
    }));

  const activeBlock = interviewSummaryBlocks.find((block) =>
    block.details?.some((detail) => detail?.id === questionId),
  );

  const blockValue = activeBlock?.id;

  if (!blockList.length || !blockValue) {
    return null;
  }

  return (
    <div className={clsx('flex flex-col justify-start gap-4', 'p-1')}>
      <div className={clsx('flex flex-row justify-start gap-4', 'hubert-vertical-center')}>
        <HubertLabel className="text-sm font-medium" htmlFor="create-question-presentation-block">
          {t('summaryBlock.label')}
        </HubertLabel>
        <InterviewSummaryBlockCombobox
          id="create-question-presentation-block"
          onValueChange={(value) => {
            if (templateId && value && value.length) {
              dispatch(
                updateQuestionInterviewSummaryBlock({
                  templateId,
                  eventType: EEventType.MODIFIED,
                  resource: {
                    blockId: blockValue,
                    questionId,
                    newBlockId: value as string,
                  },
                  description: `dddd`,
                }),
              );
            }
          }}
          list={blockList}
          value={blockValue}
        />
      </div>
      <div className="">
        <MutedText text={t('summaryBlock.hint')} />
      </div>
    </div>
  );
};

export default InTemplateInterviewSummaryBlock;
